import {Injectable} from "@angular/core";
import {CategorieDto} from "@resources/resources";

@Injectable()
export class CategoriesStore {

  private categories: Array<CategorieDto>;

  constructor() {
  }

  getCategories(): Array<CategorieDto> {
    return this.categories;
  }

  setCategories(categories: Array<CategorieDto>) {
    this.categories = categories;
  }

  getCategorieById(id: number): CategorieDto {
    let categorie = null;
    if (this.categories != null) {
      this.categories.forEach(element => {
        if (element.id == id) {
          categorie = element;
        }
      });
    }

    return categorie;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/common/store/categories.store.ts